var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-main"},[_c('div',{staticClass:"profile-main__title"},[_vm._v("Профиль компании")]),(_vm.currencies)?_c('Main',{attrs:{"currencies":_vm.currencies}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }